import React from 'react';
import { Outlet } from 'react-router-dom';

export const Facility = () => (
    <div className="mx-auto w-full max-w-[1400px]">
        <Outlet />
    </div>
);
